import { createRouter, createWebHistory } from 'vue-router'
import { hasAuthCookie } from '@/helpers/auth'
import AppShell from '@/components/layout/AppShell.vue'
import Login from '@/views/login/Index.vue'
import SetPassword from '@/views/login/SetPassword.vue'
import Conversations from '@/views/conversations/Index.vue'
import MonitoringIndex from '@/views/monitoring/Index.vue'
import DashboardsIndex from '@/views/dashboards/Index.vue'
import OperatorsIndex from '@/views/settings/agents/Index.vue'
import InboxesIndex from '@/views/settings/inboxes/Index.vue'
import InboxShow from '@/views/settings/inboxes/Show.vue'
import BlocklistIndex from '@/views/settings/blocklist/Index.vue'
import DirectoryIndex from '@/views/settings/directory/Index.vue'
import ProfileIndex from '@/views/profile/Index.vue'

const router = createRouter({
  history: createWebHistory('/app'),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/set-password',
      name: 'set_password',
      component: SetPassword,
    },
    {
      path: '/',
      component: AppShell,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'conversations',
          component: Conversations,
        },
        {
          path: 'monitoring',
          name: 'monitoring',
          component: MonitoringIndex,
        },
        {
          path: 'dashboards',
          name: 'dashboards',
          component: DashboardsIndex,
        },
        { path: 'settings', redirect: '/settings/directory' },
        {
          path: 'settings/agents',
          name: 'settings_agents',
          component: OperatorsIndex,
        },
        {
          path: 'settings/inboxes',
          name: 'settings_inboxes',
          component: InboxesIndex,
        },
        {
          path: 'settings/inboxes/:inboxId',
          name: 'settings_inbox_show',
          component: InboxShow,
        },
        {
          path: 'settings/directory',
          name: 'settings_directory',
          component: DirectoryIndex,
        },
        {
          path: 'settings/blocklist',
          name: 'settings_blocklist',
          component: BlocklistIndex,
        },
        {
          path: 'profile',
          name: 'profile',
          component: ProfileIndex,
        },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(to => {
  if (to.meta.requiresAuth && !hasAuthCookie()) {
    return { name: 'login' }
  }
  if (to.name === 'login' && hasAuthCookie()) {
    return { name: 'conversations' }
  }
  return true
})

export default router
